module.exports = __webpack_public_path__ + "img/cb-select-collapse.15768640.svg";